<script>
import storageService from "@/services/storage.service";
import Layout from "../../layouts/main";
import EasyDataTable from "vue3-easy-data-table";
import axios from "axios";
import serverTableMixin from "@/mixins/serverTable";
import "vue3-easy-data-table/dist/style.css";
import AppIcon from "@/components/shared/AppIcon.vue";
import EcuSelect from "@/components/shared/EcuSelect.vue";
import StatusChip from "@/components/shared/StatusChip.vue";
import TableFooter from "@/components/shared/TableFooter.vue";
import useVuelidate from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";


export default {
  setup() {
    return { v$: useVuelidate() };
  },
  mixins: [serverTableMixin],
  components: {
    Layout,
    EasyDataTable,
    AppIcon,
    EcuSelect,
    StatusChip,
    TableFooter,
  },
  validations() {
    return {
      firstName: { required: helpers.withMessage("First name is required", required) },
      lastName: { required: helpers.withMessage("Last name is required", required) },
      email: {
        required: helpers.withMessage("Email is required", required),
        email: helpers.withMessage("Please enter a valid email", email),
      },
      selectedRole: { required: helpers.withMessage("Role is required", required) },
      selectedBranch: { required: helpers.withMessage("Branch name is required", required) },
    };
  },
  data() {
    return {
      roles: [
        { text: "Staff", value: "staff" },
        { text: "Verification Officer", value: "verification officer" },
      ],
      selectedRole: "staff",
      submitted: false, // the Add form was submitted at least once (shows the required messages)
      deactivateOpen: false, // confirmation before a staff member is made inactive
      pendingStaffId: null,
      branchs: [
        { text: "Arima", value: "Arima" },
        { text: "Barataria", value: "Barataria" },
        { text: "Chaguanas", value: "Chaguanas" },
        { text: "Port of Spain", value: "Port of Spain" },
        { text: "Sande Grande", value: "Sande Grande" },
        { text: "San Fernando", value: "San Fernando" },
        { text: "St. Joseph - La Joya", value: "St. Joseph - La Joya" },
        { text: "Tobago", value: "Tobago" },
      ],
      selectedBranch: "Arima",
      firstName: "",
      lastName: "",
      email: "",
      admin: "yes",
      addStaff: false,

      edit_firstName: "",
      edit_lastName: "",
      edit_email: "",
      edit_selectedRole: "",
      edit_selectedBranch: "",
      successMessage: false,
      archiveStaff: false,
      viewStaff: false,
      editStaff: false,
      selectFilterSort: "Active", // Active staff are listed by default
      searchValueTable: "",
      sortFieldMap: {},
      password: this.value,
      headers: [
        { text: "Name", value: "staffname" },
        { text: "Emails", value: "staffemail" },
        { text: "Branch Name", value: "staffbranch" },
        { text: "Roles", value: "staffrole" },
        { text: "Status", value: "staffstatus" },
        { text: "Action", value: "staffaction" },
        { text: "Active/Inactive", value: "stafftoggleBtn" },
      ],
      items: [],
      arrItem: [],
    };
  },
  computed: {
    statusFilterChoices() {
      return [
        { value: "Active", label: "Active Staff" },
        { value: "Inactive", label: "Inactive Staff" },
        { value: "Pending", label: "Pending Staff" },
      ];
    },
    roleOptions() {
      return this.roles.map((r) => ({ value: r.value, label: r.text }));
    },
    branchOptions() {
      return this.branchs.map((b) => ({ value: b.value, label: b.text }));
    },
  },
  watch: {
    addStaff(open) {
      if (!open) this.resetAddForm();
    },
  },
  mounted() {
    if (this.auto == "true" || this.auto == 1) {
      this.generate();
    }
  },
  created() {
    this.loadTable();
  },
  methods: {
    printCSV() {
      const rows = [
        ["Column 1", "Column 2"],
        [1, 2],
        [3, 4],
      ]; // replace with your table data
      const csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "table.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    duplicateItem() {
      this.itemsss.push(Date.now());
    },
    generate() {
      let CharacterSet =
        "abcdefghijklmnopqrstuvwxyz![]{}()ABCDFASDFFG1234582475%&*$#^<>~@|";
      let password = "";
      for (let i = 0; i < this.size; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      this.password = password;
    },
    requestTable(params) {
      return axios.get("/applications/admin_staffwise_stats/", { params });
    },
    // footer controls -> the server-side table options (the mixin reloads on change)
    onPageChange(page) {
      this.serverOptions = { ...this.serverOptions, page };
    },
    onRowsChange(rowsPerPage) {
      this.serverOptions = { ...this.serverOptions, rowsPerPage, page: 1 };
    },
    staffTone(status) {
      return { Active: "green", Inactive: "blue" }[status] || "red";
    },

    applyTable(data) {
      this.arrItem = (data.results || []).map((item) => ({
        Staff_Id: item.staff_id,
        staffname: item.staff_name,
        staffemail: item.email,
        staffbranch: item.branch || "N/A",
        staffrole: item.role,
        staffstatus: item.staff_status,
        staffaction: "edit/delete",
        toggleBtnUrl: `${item.staff_id}`,
      }));
    },

    // Making a staff member inactive needs a confirmation; activating does not.
    toggleCheckbox(toggleBtnUrl, event) {
      const isChecked = event?.target?.checked;
      const targetId = parseInt(toggleBtnUrl);
      if (!isChecked) {
        event.preventDefault(); // the switch stays on until the person confirms
        this.pendingStaffId = targetId;
        this.deactivateOpen = true;
        return;
      }
      this.updateStaffStatus(targetId, true, event);
    },
    confirmDeactivate() {
      const id = this.pendingStaffId;
      this.deactivateOpen = false;
      this.pendingStaffId = null;
      if (id) this.updateStaffStatus(id, false);
    },
    updateStaffStatus(targetId, isChecked, event) {
      axios
        .post("/accounts/toggle_staff_activation/", {
          aid: targetId,
          verifyit: isChecked,
          tn: storageService.getItem("accessToken"),
        })
        .then((response) => {
          if (response.data.status === "SUCCESS") {
            // the Active/Inactive filter depends on the new status
            this.loadTable(true);
          }
        })
        .catch((error) => {
          console.error("Error toggling staff status:", error);
          if (event && event.target) {
            event.target.checked = !isChecked;
          }
        });
    },

    clearSearch() {
      this.searchValueTable = "";
      clearTimeout(this.searchTimer);
      this.resetAndLoad();
    },
    openAdd() {
      this.resetAddForm();
      this.addStaff = true;
    },
    resetAddForm() {
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.selectedRole = "staff";
      this.selectedBranch = "Arima";
      this.submitted = false;
      this.v$.$reset();
    },
    addmember() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) return;
      axios
        .post("/accounts/add_member/", {
          email: this.email.trim(),
          first_name: this.firstName.trim(),
          last_name: this.lastName.trim(),
          role: this.selectedRole,
          branch: this.selectedBranch,
        })
        .then((response) => {
          // Handle the response
          if (response.data.msg === "Memeber Added Successfully") {
            location.reload();
          }
        })

        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
        });
    },
    openEditModal(staffId) {
      this.selectedStaffId = staffId;

      this.loadStaffDetails(staffId); // Method to load staff details for editing
      this.editStaff = true;
    },
    loadStaffDetails(staffId) {

      axios.post(`/accounts/get_staff_member/${staffId}`).then((response) => {
        const staff = response.data.status;

        this.edit_firstName = staff.first_name;
        this.edit_lastName = staff.last_name;
        this.edit_email = staff.email;
        this.edit_selectedRole = staff.role;
        this.edit_selectedBranch = staff.branch_name;
      });
    },
    editmember() {
      axios
        .post("/accounts/edit_member/", {
          staffId: this.selectedStaffId,
          email: this.edit_email,
          first_name: this.edit_firstName,
          last_name: this.edit_lastName,
          role: this.edit_selectedRole,
          branch: this.edit_selectedBranch,
        })
        .then((response) => {
          if (response.data.msg === "Edited Successfully") {
            this.successMessage = true; // Show success message
            location.reload();  
            setTimeout(() => {
              this.successMessage = false;
              this.editStaff = false;
            }, 3000);
          }
        })

        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
        });
    },
  },
};
</script>

<template>
  <Layout>
    <section class="staff">
      <header class="ecu-page-head">
        <div class="staff__title">
          <h1>Staff Users</h1>
          <p class="ecu-page-head__sub">Manage staff members and their access.</p>
        </div>

        <div class="staff__tools">
          <div class="ecu-field ecu-field--search">
            <AppIcon name="search" :size="18" />
            <input
              type="text"
              v-model="searchValueTable"
              @input="onSearchInput"
              placeholder="Search staff..."
              aria-label="Search staff"
            />
            <button
              v-if="searchValueTable"
              type="button"
              class="staff__clear"
              aria-label="Clear search"
              @click="clearSearch"
            >
              <AppIcon name="x" :size="14" :stroke="2.4" />
            </button>
          </div>

          <EcuSelect
            v-model="selectFilterSort"
            class="ecu-filter-select"
            :options="statusFilterChoices"
            aria-label="Filter by status"
            @change="onStatusChange"
          />

          <router-link to="/archived_staff_member" class="ecu-text-link">
            Archived Staff
            <AppIcon name="arrow-right" :size="16" :stroke="2.2" />
          </router-link>

          <a href="javascript:void(0);" class="ecu-btn-add" @click="openAdd">+ Add Staff</a>
        </div>
      </header>

      <div class="ecu-card">
        <!-- Add modal -->
        <b-modal
          title="Add Staff Member"
          v-model="addStaff"
          hide-footer
          centered
        >
          <form class="ecu-m-form staff-form" novalidate @submit.prevent="addmember()">
            <div class="ecu-m-grid">
              <div class="ecu-m-field">
                <label class="ecu-m-label" for="add-first">First Name</label>
                <input
                  id="add-first"
                  v-model="firstName"
                  type="text"
                  class="ecu-m-input"
                  :class="{ 'is-invalid': submitted && v$.firstName.$error }"
                  placeholder="First Name"
                />
                <div v-if="submitted && v$.firstName.$error" class="invalid-feedback d-block">
                  {{ v$.firstName.$errors[0].$message }}
                </div>
              </div>
              <div class="ecu-m-field">
                <label class="ecu-m-label" for="add-last">Last Name</label>
                <input
                  id="add-last"
                  v-model="lastName"
                  type="text"
                  class="ecu-m-input"
                  :class="{ 'is-invalid': submitted && v$.lastName.$error }"
                  placeholder="Last Name"
                />
                <div v-if="submitted && v$.lastName.$error" class="invalid-feedback d-block">
                  {{ v$.lastName.$errors[0].$message }}
                </div>
              </div>
              <div class="ecu-m-field">
                <label class="ecu-m-label" for="add-email">Email</label>
                <input
                  id="add-email"
                  v-model="email"
                  type="email"
                  class="ecu-m-input"
                  :class="{ 'is-invalid': submitted && v$.email.$error }"
                  placeholder="Email"
                />
                <div v-if="submitted && v$.email.$error" class="invalid-feedback d-block">
                  {{ v$.email.$errors[0].$message }}
                </div>
              </div>
              <div class="ecu-m-field">
                <label class="ecu-m-label">Role</label>
                <EcuSelect
                  v-model="selectedRole"
                  :class="{ 'is-invalid-field': submitted && v$.selectedRole.$error }"
                  :options="roleOptions"
                  aria-label="Role"
                />
                <div v-if="submitted && v$.selectedRole.$error" class="invalid-feedback d-block">
                  {{ v$.selectedRole.$errors[0].$message }}
                </div>
              </div>
              <div class="ecu-m-field ecu-m-field--wide">
                <label class="ecu-m-label">Branch Name</label>
                <EcuSelect
                  v-model="selectedBranch"
                  :class="{ 'is-invalid-field': submitted && v$.selectedBranch.$error }"
                  :options="branchOptions"
                  aria-label="Branch name"
                />
                <div v-if="submitted && v$.selectedBranch.$error" class="invalid-feedback d-block">
                  {{ v$.selectedBranch.$errors[0].$message }}
                </div>
              </div>
            </div>
            <div class="ecu-m-actions">
              <button type="button" class="ecu-m-btn ecu-m-btn--ghost" @click="addStaff = false">
                Cancel
              </button>
              <button type="submit" class="ecu-m-btn">Add</button>
            </div>
          </form>
        </b-modal>

        <div class="ecu-table-wrap">
          <EasyDataTable
            header-text-direction="center"
            :headers="headers"
            :items="arrItem"
            v-model:server-options="serverOptions"
            :server-items-length="totalItems"
            :loading="tableLoading"
            :rows-items="[10, 20, 50, 100]"
            empty-message="No staff members found"
            theme-color="#f97316"
            hide-footer
            table-class-name="table-custom-style noWrapHeading"
          >
            <template #item-staffemail="{ staffemail }">
              <span class="ecu-nocap">{{ staffemail }}</span>
            </template>
            <template #item-staffname="{ staffname }">
              <span class="ecu-strong">{{ staffname }}</span>
            </template>
            <template #item-staffstatus="{ staffstatus }">
              <StatusChip :label="`${staffstatus}`" :tone="staffTone(`${staffstatus}`)" />
            </template>
            <template #item-staffaction="{ Staff_Id }">
              <div class="ecu-actions">
                <router-link
                  class="ecu-btn-view"
                  title="View Staff"
                  :to="`/single_staff/${Staff_Id}`"
                >
                  <AppIcon name="eye" :size="16" /> View
                </router-link>
                <button
                  type="button"
                  class="ecu-btn-view"
                  title="Edit Staff"
                  @click="openEditModal(Staff_Id)"
                >
                  <AppIcon name="edit" :size="16" /> Edit
                </button>
              </div>
            </template>
            <template #item-stafftoggleBtn="{ toggleBtnUrl, staffstatus }">
              <label
                class="ecu-switch"
                v-if="staffstatus == 'Active' || staffstatus == 'Inactive'"
              >
                <input
                  type="checkbox"
                  :checked="staffstatus == 'Active'"
                  @click="toggleCheckbox(toggleBtnUrl, $event)"
                />
                <span class="ecu-switch__slider"></span>
              </label>
            </template>
          </EasyDataTable>
        </div>

        <TableFooter
          :page="serverOptions.page"
          :rows-per-page="serverOptions.rowsPerPage"
          :total="totalItems"
          :loading="tableLoading"
          @update:page="onPageChange"
          @update:rowsPerPage="onRowsChange"
        />

        <!-- one shared Edit modal (was repeated inside every table row) -->
        <b-modal
          title="Edit Staff Member"
          v-model="editStaff"
          hide-footer
          centered
        >
          <form class="ecu-m-form" @submit.prevent="editmember()">
            <p v-if="successMessage" class="ecu-m-alert ecu-m-alert--success">
              <AppIcon name="check-circle" :size="18" />
              Successfully edited. Please wait...
            </p>
            <div class="ecu-m-grid">
        <div class="ecu-m-field">
          <label class="ecu-m-label">First Name</label>
          <input id="edit-first" v-model="edit_firstName" type="text" class="ecu-m-input" placeholder="First Name" />
        </div>
        <div class="ecu-m-field">
          <label class="ecu-m-label">Last Name</label>
          <input id="edit-last" v-model="edit_lastName" type="text" class="ecu-m-input" placeholder="Last Name" />
        </div>
        <div class="ecu-m-field">
          <label class="ecu-m-label">Email</label>
          <input id="edit-email" v-model="edit_email" type="email" class="ecu-m-input" placeholder="Email" disabled />
        </div>
        <div class="ecu-m-field">
          <label class="ecu-m-label">Role</label>
          <EcuSelect v-model="edit_selectedRole" :options="roleOptions" aria-label="Role" />
        </div>
        <div class="ecu-m-field ecu-m-field--wide">
          <label class="ecu-m-label">Branch Name</label>
          <EcuSelect v-model="edit_selectedBranch" :options="branchOptions" aria-label="Branch name" />
        </div>
            </div>
            <div class="ecu-m-actions">
              <button type="button" class="ecu-m-btn ecu-m-btn--ghost" @click="editStaff = false">
                Cancel
              </button>
              <button type="submit" class="ecu-m-btn">Save changes</button>
            </div>
          </form>
        </b-modal>

        <b-modal
          title="Inactivate Staff Member"
          v-model="deactivateOpen"
          hide-footer
          centered
        >
          <div class="ecu-m-confirm">
            <span class="ecu-m-confirm__icon"><AppIcon name="alert" :size="28" /></span>
            <h5>Do you really want to make<br />this staff member inactive?</h5>
            <div class="ecu-m-actions ecu-m-actions--center">
              <button class="ecu-m-btn ecu-m-btn--ghost" type="button" @click="deactivateOpen = false">
                No
              </button>
              <button class="ecu-m-btn" type="button" @click="confirmDeactivate">Yes</button>
            </div>
          </div>
        </b-modal>
      </div>
    </section>
  </Layout>
</template>

<style scoped>
.staff {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
/* heading on the left, tools on the right, all on one line */
.staff .ecu-page-head {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 16px;
}
.staff__title {
  flex: 0 0 auto;
  white-space: nowrap;
}
.staff .ecu-card {
  padding: 22px 22px 18px;
}
.staff .ecu-toolbar .ecu-tile {
  background: transparent;
}
/* search, status, Archived Staff and + Add Staff on one line, top right */
.staff__tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  flex: 1 1 auto;
  min-width: 0;
  gap: 12px;
  align-self: center;
}
.staff__tools > * {
  flex-shrink: 0;
}
.staff__tools .ecu-field--search {
  flex: 0 1 240px;
  min-width: 150px;
}
/* compact status dropdown so it never runs over the heading */
.staff__tools .ecu-filter-select {
  flex: 0 0 140px;
  width: 140px;
  min-width: 0;
  max-width: 140px;
}
.staff__tools .ecu-filter-select :deep(.es__trigger) {
  height: 44px;
  padding-left: 12px;
  padding-right: 10px;
  font-size: 14px;
  white-space: nowrap;
}
.staff__tools .ecu-field--search input {
  padding-right: 40px;
  width: 100%;
}
.staff__tools .ecu-text-link,
.staff__tools .ecu-btn-add {
  box-sizing: border-box;
  height: 44px;
  white-space: nowrap;
}
.staff__clear {
  position: absolute;
  right: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #5f6579;
  cursor: pointer;
}
.staff__clear:hover {
  color: #e84d00;
}

/* Add Staff form: one field look (inputs and dropdowns), regular-weight labels */
.staff-form .ecu-m-label {
  font-weight: 400;
}
.staff-form .ecu-m-input,
.staff-form :deep(.es__trigger) {
  box-sizing: border-box;
  height: 44px;
  border: 1px solid #e3e6f0;
  border-radius: 12px;
  font-size: 14px;
}
.staff-form .ecu-m-input.is-invalid,
.staff-form .is-invalid-field :deep(.es__trigger) {
  border-color: #dc3545;
}
.staff-form .invalid-feedback {
  margin-top: 4px;
  font-size: var(--ecu-fs-small);
}
/* narrower screens: allow the row to wrap so nothing overflows */
@media (max-width: 1199px) {
  .staff .ecu-page-head {
    flex-wrap: wrap;
  }
  .staff__tools {
    flex-wrap: wrap;
  }
}
@media (max-width: 767px) {
  .staff__tools {
    width: 100%;
    justify-content: stretch;
  }
  .staff .ecu-card {
    padding: 16px 14px 14px;
  }
}
</style>